<template>
  <v-container fluid pa-3 background>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-form ref="form" v-model="form_valid">
          <v-layout row wrap>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                v-model="datas.code"
                required
                :label="$t('doc_no')"
                append-icon="fas fa-plus-circle"
                hide-details
                @click:append="doNewGuid"
              />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('date')"
                type="date"
                v-model="datas.date"
                required
                hide-details
              />
            </v-flex>
            <v-flex md4 sm6 xs12 pa-1>
              <v-text-field
                :label="$t('remark')"
                type="text"
                v-model="datas.remark"
                required
                hide-details
              />
            </v-flex>

            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="branch_items"
                :label="$t('branch')"
                item-text="name"
                item-value="code"
                v-model="branch"
                hide-details
                @input="getProfileDepartmentList()"
              />
            </v-flex>
            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
              <v-select
                required
                :items="department_items"
                :label="$t('Department')"
                item-text="name"
                item-value="code"
                v-model="department"
                hide-details
                :disabled="department_items.length ==''"
                @input="getEmployeeList()"
              />
            </v-flex>

            <v-flex md4 sm6 xs12 pa-1>
               <v-autocomplete
                v-model="name"
                :items="Employee_list"
                item-text="name"
                item-value="name"
                :label="$t('employee_code')"
                :disabled="Employee_list.length ==''"
                append-icon="search"
                clearable
                hide-details
                required
                multiple
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <span v-if="index === 0">{{ item.name }}</span>
                  <span
                    v-if="index === 1"
                    class="grey--text caption"
                  >(+{{ name.length - 1 }} others)</span>
                </template>
                <template slot="prepend-item">
                  <v-list-tile ripple @click="toggle" class="checkEmp">
                    <v-list-tile-action>
                      <v-checkbox
                        v-model="isChecked"
                        color="primary"
                        :indeterminate="selectSomeEmp"
                      ></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Select All</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template slot="append-item">
                  <v-divider class="mb-2"></v-divider>
                </template>
               </v-autocomplete>
            </v-flex>
            <v-flex
              md2
              sm6
              xs12
              style="margin-right:15px;"
              v-if="permission_edit == true || admin == 'true'"
            >
              <v-btn color="warning" block class="white--text" @click="CreateDoc()">
                <p style=" font-size:12px;position: absolute;margin-top:15px;">{{$t('DownloadExample')}}</p>
              </v-btn>
            </v-flex>
            <v-flex
              md2
              sm6
              xs12
              class="button-wrapper"
              v-if="permission_edit == true || admin == 'true'"
            >
              <span class="label">{{$t('Upload')}}</span>
              <input
                :label="$t('ImportIncome')"
                type="file"
                id="file"
                ref="myFiles"
                class="upload-box"
                multiple
                @change="ImportExcel()"
                placeholder="Upload File"
              />
            </v-flex>
            <v-flex md2 sm6 xs12 style="margin-right:15px;" v-if="datas.details.length > 0">
              <v-btn color="#D84315" block class="white--text" @click="back()">
                <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                <span style="color:#ffffff">{{$t('back')}}</span>
              </v-btn>
            </v-flex>
            <v-flex md2 sm6 xs12 style="margin-right:15px;" v-if="datas.details.length > 0">
              <v-btn color="#43A047" block class="white--text" @click="dialog = false;onSave()">
                <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                <span style="color:#ffffff">{{$t('save')}}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="finger_scan_data.length > 0">
            <v-flex
              md12
              sm12
              xs12
              v-for="(item, index) in finger_scan_data"
              :key="index"
              @click="''"
            >
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center>
                    <v-avatar :size="64">
                      <v-avatar
                        v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                        :size="64"
                        color="teal"
                      >
                        <span class="white--text headline">{{item.nick_name}}</span>
                      </v-avatar>

                      <Empimage
                        v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                        :json_data="item.emp_images"
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex lg9 md9 sm8 xs9>
                    <v-layout row wrap>
                      <!-- <v-flex xs12>
                        <span
                          class="coco-list-label-text"
                        >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>
                        <span>{{item.name}}</span>
                       
                      </v-flex>-->
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs2>
                            <span
                              class="coco-list-label-text"
                            >{{$t('employee_code')}} : {{item.emp_code}}</span>
                          </v-flex>
                          <v-flex xs2>
                            <span class="coco-list-label-icon">
                              <v-icon>date_range</v-icon>
                              <span>{{formatdateTime(item.date_finger_scan)}}</span>
                            </span>
                          </v-flex>
                          <v-flex xs2>
                            <span class="coco-list-label-icon">
                              <v-icon>info</v-icon>
                              <span>{{isEmpty(item.remark) ? item.remark : '-'}}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item,index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item,index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{$t('delete')}}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>

      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>

      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('EditDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('code')"
                      v-model="form_dialog.emp_code"
                      required
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('name')" v-model="form_dialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('date')"
                      type="date"
                      v-model="form_dialog.date_finger_scan"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_dialog.remark" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('duration')"
                      v-model="form_dialog.time_finger_scan"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">{{$t('close')}}</v-btn>
              <v-btn color="blue darken-1" flat @click="dialog = false;onUpdate()">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Form Create Doc -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog_create" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('CreateDocument')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('date')"
                      type="datetime-local"
                      v-model="form_dialog_create.date"
                      required
                      hide-details
                      :rules="form_rules.date"
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      :label="$t('detail')"
                      v-model="form_dialog_create.remark"
                      required
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog_create = false">{{$t('close')}}</v-btn>
              <v-btn color="blue darken-1" flat @click="DownloadExampleExcel()">{{$t('save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
      <div class="text-xs-center">
        <v-dialog v-model="dialog_loading" persistent width="60vh">
          <v-card>
            <v-card-text align-center align-content-center justify-center>
              <v-layout row wrap>
                <v-flex xs12 pa-3>
                  <h4>Processing....</h4>
                  <v-progress-linear v-model="process_upload" height="25" reactive color="amber">
                    <strong>{{ Math.ceil(process_upload) }}%</strong>
                  </v-progress-linear>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Empimage from "../../components/getempimage.vue";
import UserService from "@/services/UserService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    dialog_loading: false,
    dialog_create: false,
    branch: "",
    process_upload: 0,
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    isChecked: false,
    form_valid: false,
    dialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    form_rules: {
      date: [v => !!v || "do not empty."]
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    index: 0,
    form_dialog: {
      emp_code: "",
      name: "",
      date_finger_scan: "",
      time_finger_scan: "",
      remark: ""
    },
    form_dialog_create: {
      date: "",
      remark: ""
    },
    head_example: ["รหัส", "วันเวลาที่สแกนนิ้ว", "หมายเหตุ"],
    detail_example: [],
    datas: {
      code: "",
      remark: "",
      date: new Date().toISOString().slice(0, 10),
      creator_code: localStorage._usercode,
      details: []
    },
    results: [],
    finger_scan_data: [],
    name: [],
    checkdata: true,
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: []
  }),

  components: {
    DeleteDialog,
    Empimage
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
    ...mapState("filter", ["Employee_List"]),
    //...mapState("permissionmenu", ["permission_List"]),

    selectAllEmp() {
      return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  created: async function() {
    await UserService.getpermissionByusercode(this.empCode)
      .then(res => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch(err => {});
    await this.checkpermission("ImportFingerScan");
    this.admin = localStorage._is_admin;
    console.log(this.check_permission);
    this.doNewGuid();
    this.getEmployee("newData");
    this.getProfileBranchList();
    this.commitSetToolbar({ patternTool: "0" });
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),

    goto(path) {
      this.$router.push("/" + path);
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatdateTime(date) {
      return moment(date).format("DD/MM/YYYY H:mm:ss");
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    doNewGuid() {
      this.datas.code = Utils.newGuid(
        "FS" + this.formatdateDoc(this.datas.date)
      );
    },
    CreateDoc() {
      let v = this;
      if (v.name.length > 0) {
        this.dialog_create = true;
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
      }
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach(element => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    DownloadExampleExcel() {
      let v = this;
      console.log("DownloadExampleExcel");
      console.log(v.name);
      v.detail_example = [];
      if (v.name.length > 0) {
        if (v.form_dialog_create.date != "") {
          v.dialog_create = false;
          v.name.forEach(function(data) {
            let value = data.split(" - ");
            console.log(value[0] + " : " + value[1]);
            v.detail_example.push({
              รหัส: value[0],
              วันเวลาที่สแกนนิ้ว:
                v.form_dialog_create.date.replace("T", " ") + ":00",
              หมายเหตุ: v.form_dialog_create.remark
            });
          });
          var config = { raw: true, type: "string" };
          var Example = XLSX.utils.json_to_sheet(
            v.detail_example,
            v.head_example,
            config
          );
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, Example, "ลงเวลา");
          XLSX.writeFile(wb, "ลงเวลา" + ".xlsx");
        } else {
          this.snack_model.status = true;
          this.snack_model.msg = "กรุณากรอกวันที่มีสแกนนิ้ว";
          this.snack_model.type = "error";
        }
      } else {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณาเลือกรายชื่อพนักงานก่อน";
        this.snack_model.type = "error";
      }
      this.form_dialog_create.date = "";
      this.form_dialog_create.remark = "";
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        console.log(v.results);
        //console.log("5555");
        v.datas.details = [];
        for (let index = 0; index < v.results.length; index++) {
          if (
            v.results[index].รหัส != " " &&
            v.results[index].วันเวลาที่สแกนนิ้ว != " "
          ) {
            v.datas.details.push({
              emp_code: v.results[index].รหัส,
              date_finger_scan: v.results[index].วันเวลาที่สแกนนิ้ว,
              remark: v.results[index].หมายเหตุ
            });
          } else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          }
        }
        v.finger_scan_data = v.datas.details;
        console.log("dddd", v.finger_scan_data);
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },

    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            console.log("eeee", this.branch_items);
          } else {
            console.log("ddddd");
            console.log(this.Employee_List);
            this.Employee_List.forEach(emp => {
              this.Employee_list.push(emp);
            });
            console.log(this.Employee_list);
          }
        })
        .catch(err => {
          console.log(err);
          console.log("ddddd");
          this.Employee_List.forEach(emp => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log(this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    },

    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.emp_code +
        " " +
        // data.name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
    },

    onDelete() {
      console.log(this.delete_dialog_data.index);
      //this.finger_scan_data.splice(this.delete_dialog_data.index, 1);
      this.datas.details.splice(this.delete_dialog_data.index, 1);
      console.log("ondelete: importincome", this.finger_scan_data);
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },
    async onSave() {
      let v = this;
      let datascan = [];
      let date = "";
      v.finger_scan_data.forEach(data => {
        if (data.status == false) {
          v.checkdata = false;
        }
      });

      console.log(v.checkdata);
      if (v.checkdata != false) {
        console.log(v.datas);
        v.datas.details.forEach(detail => {
          let date = detail.date_finger_scan + ".0";
          datascan.push({
            usercode: detail.emp_code,
            doc_no: v.datas.code,
            remark: v.datas.remark,
            check_in_time: date
          });
        });

        console.log("666", datascan);
        let total_row = datascan.length;
        let data_send = [];
        let per_row = 100;
        let row = 0;
        let round = 0;
        let json_array = [];
        for (row; row < total_row; row++) {
          json_array.push(datascan[row]);

          if (row == per_row - 1) {
            data_send.push(json_array);
            json_array = [];
            per_row += 100;
          } else if (row == total_row - 1) {
            data_send.push(json_array);
            json_array = [];
            per_row = 100;
          }
        }

        this.dialog_loading = true;

        this.process_upload = 0;
        var time = 1000;
        let x = 0;
        for await (let dataz of data_send) {
          console.log(dataz);

          await DocumentService.createCheckinout(dataz)
            .then(res => {
             // console.log(x);
              if (data_send.length - 1 == 0) {
                v.process_upload = 100;
              } else {
                v.process_upload = (x / (data_send.length - 1)) * 100;
              }

              x++;

              console.log(v.process_upload);
              if (v.process_upload == 100) {
                v.dialog_loading = false;
                v.snack_model.status = true;
                v.datas.details = [];
                v.snack_model.msg = "save success";
                v.snack_model.type = "success";
                v.goto("checkinout/list");
              }
            })
            .catch(err => {
              v.snack_model.status = true;
              v.snack_model.msg = err.message;
              v.snack_model.type = "error";
              v.dialog_loading = false;
            });
        }
      } else {
        v.snack_model.status = true;
        v.snack_model.msg = "กรุณาตรวจสอบข้อมูลและทำการอัพโหลดไฟล์ใหม่";
        v.snack_model.type = "error";
        v.dialog_loading = false;
        window.onload = this.timedRefresh(1500);
      }
    },

    onUpdate() {
      let v = this;
      (v.datas.details[v.index].emp_code = v.form_dialog.emp_code),
        (v.datas.details[v.index].name = v.form_dialog.name),
        (v.datas.details[v.index].date_finger_scan =
          v.form_dialog.date_finger_scan),
        (v.datas.details[v.index].time_finger_scan =
          v.form_dialog.time_finger_scan),
        (v.datas.details[v.index].remark = v.form_dialog.remark),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    back() {
      location.reload();
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_list.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
</style>
<style type="text/css">
@keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@-webkit-keyframes lds-pacman-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  50% {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
@keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@-webkit-keyframes lds-pacman-2 {
  0% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  50% {
    -webkit-transform: rotate(225deg);
    transform: rotate(225deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
@-webkit-keyframes lds-pacman-3 {
  0% {
    -webkit-transform: translate(190px, 0);
    transform: translate(190px, 0);
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  100% {
    -webkit-transform: translate(70px, 0);
    transform: translate(70px, 0);
    opacity: 1;
  }
}
.lds-pacman {
  position: relative;
}
.lds-pacman > div:nth-child(2) div {
  position: absolute;
  top: 40px;
  left: 40px;
  width: 120px;
  height: 60px;
  border-radius: 120px 120px 0 0;
  background: #3be8ce;
  -webkit-animation: lds-pacman-1 0.9s linear infinite;
  animation: lds-pacman-1 0.9s linear infinite;
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px;
}
.lds-pacman > div:nth-child(2) div:nth-child(2) {
  -webkit-animation: lds-pacman-2 0.9s linear infinite;
  animation: lds-pacman-2 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div {
  position: absolute;
  top: 92px;
  left: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #1ec7ed;
  -webkit-animation: lds-pacman-3 0.9s linear infinite;
  animation: lds-pacman-3 0.9s linear infinite;
}
.lds-pacman > div:nth-child(1) div:nth-child(1) {
  -webkit-animation-delay: -0.603s;
  animation-delay: -0.603s;
}
.lds-pacman > div:nth-child(1) div:nth-child(2) {
  -webkit-animation-delay: -0.297s;
  animation-delay: -0.297s;
}
.lds-pacman > div:nth-child(1) div:nth-child(3) {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.lds-pacman {
  width: 200px !important;
  height: 200px !important;
  -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
  transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
}
</style>